import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormFieldErrorDirective } from './error.directive';
import { FormFieldComponent } from './form-field.component';
import { FormFieldHintDirective } from './hint.directive';
import { FormFieldLabelDirective } from './label.directive';
import {
  FormFieldPrefixDirective,
  FormFieldSuffixDirective,
} from './prefix-suffix.directive';

const EXPORTED = [
  FormFieldComponent,
  FormFieldLabelDirective,
  FormFieldErrorDirective,
  FormFieldHintDirective,
  FormFieldPrefixDirective,
  FormFieldSuffixDirective,
];

@NgModule({
  imports: [CommonModule, ObserversModule],
  declarations: EXPORTED,
  exports: EXPORTED,
})
export class FormFieldModule {}
